<template>
  <modal :show.sync="showModal" size="lg">
    <h6 slot="header" class="modal-title">Editar Plan: {{fetchPlan.name}}</h6>
    <form class="needs-validation" id="formEditUser"
        @submit.prevent="sendForm">
      <div class="form-row">
          <div class="col-md-12">
                <base-input label="Categoria:">
                    <el-select :disabled="true" @change="updateSubcategoriasList" v-model="plan.categoria.id" filterable
                                placeholder="Seleccione Categoria">
                        <el-option v-for="option in selectCategorias"
                                    :key="option.label"
                                    :label="option.label"
                                    :value="option.value">
                        </el-option>
                    </el-select>
                </base-input>
          </div>
      </div>
      <div class="form-row">
          <div class="col-md-12">
                <base-input label="Subcategoria:">
                    <el-select :disabled="true" v-model="plan.subcategoria.id" filterable
                                placeholder="Seleccione Subcategoria">
                        <el-option v-for="option in selectSubcategorias"
                                    :key="option.label"
                                    :label="option.label"
                                    :value="option.value">
                        </el-option>
                    </el-select>
                </base-input>
          </div>
      </div>
      <div class="form-row">
          <div class="col-md-12">
                <base-input label="Compañia:">
                    <el-select v-model="plan.compañia.id" filterable
                                placeholder="Seleccione Compañia">
                        <el-option v-for="option in selectCompañias"
                                    :key="option.label"
                                    :label="option.label"
                                    :value="option.value">
                        </el-option>
                    </el-select>
                </base-input>
          </div>
      </div>
      <div class="form-row">
          <div class="col-md-12">
                <base-input label="Sponsor:">
                    <el-select v-model="plan.sponsor.id" filterable
                                placeholder="Seleccione Sponsor">
                        <el-option v-for="option in selectSponsors"
                                    :key="option.label"
                                    :label="option.label"
                                    :value="option.value">
                        </el-option>
                    </el-select>
                </base-input>
          </div>
      </div>
      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Nombre"
                      name="nombre"
                      placeholder="Ingrese un nombre"
                      :error="getError('nombre')"
                      v-validate="'required'"
                      v-model="plan.name">
          </base-input>
        </div>
      </div>
      <h1 class="display-4">Filtros de búsqueda</h1>
    
      <div class="form-row" v-for="(item,i) in campos_enum" :key="i">
          <div class="col-md-12">
            <base-input :label="'Elija qué opción ['+(item.nombre_publico || item.nombre_identificatorio)+'] corresponde:'">
                <el-select  v-model="plan.campos_enum[i]" filterable
                            placeholder="Seleccione opción...">
                    <el-option v-for="option in item.opciones"
                                :key="option"
                                :label="option"
                                :value="option">
                    </el-option>
                </el-select>
            </base-input>
          </div>
      </div>
      <div class="form-row" v-for="(itm,iql) in campos_range" :key="iql+'A'">
          <div class="col-md-6" >
            <base-input v-model="plan.campos_range[iql].desde" :label="'Filtrar ['+(itm.nombre_publico || itm.nombre_identificatorio)+'] desde:'" type="number" step="0.001" />
          </div>
          <div class="col-md-6" >
            <base-input v-model="plan.campos_range[iql].hasta" :label="'Filtrar ['+(itm.nombre_publico || itm.nombre_identificatorio)+'] hasta:'" type="number" step="0.001" />
          </div>
      </div>
      
      <h1 class="display-4">Pricing</h1>
      <p class="lead" style="font-size: 0.8rem;" >
        En este apartado puedes definir la fórmula de pricing que tendrá el plan, o en su defecto el valor fijo en la moneda asociada al plan. Puedes utilizar las siguientes variables en la fórmula por su respectiva letra.
      </p>
      <h4  v-if="campos_formulas.length > 0">Variables:</h4>
      
      <div class="row" v-if="campos_formulas.length > 0">
          <div class="table-responsive">
              <base-table class="table  mt-1"
                          :data="campos_formulas">
                  <template slot="columns">
                      <th class="text-center px-0 bg-transparent" scope="col">Variable</th>
                      <th class="text-center bg-transparent" scope="col">Letra </th>
                  </template>
                  
                  <template slot-scope="{row,index}">
                      <td class="text-center px-0">{{row.nombre_publico || row.nombre_identificatorio}}</td>
                      <td class="text-center">{{letras[index]}}</td>
                  </template>
                  
              </base-table>
          </div>
      </div>
      
      <h4>Fórmula pricing:</h4>
      <div class="form-row">
        <div class="col-md-12">
          <base-input v-model="formula" label="Escriba la fórmula:"  placeholder="ej: (3*x + 12000)/0.75*y" />
          <small>Nota: Para multiplicación debe utilizar explicitamente el operador *</small>
        </div>
      </div>
      <badge v-if="formulaComputed" rounded type="success">Formula Correcta</badge>
      <badge v-if="!formulaComputed" rounded type="danger">Formula Incorrecta</badge>

      <div class="form-row mt-2">
        <div class="col-md-12">
              <base-input label="Materia asegurada"
                          name="materia asegurada"
                          :error="getError('materia asegurada')"
                          v-validate="'required'"
                          v-model="plan.materia"
              >
                  <el-select clearable v-model="plan.materia" filterable
                              placeholder="Seleccione la materia a asegurar en este plan">
                      <el-option v-for="option in selectMaterias"
                                  :key="option.label"
                                  :label="option.label"
                                  :value="option.value">
                      </el-option>
                  </el-select>
              </base-input>
        </div>
      </div>

      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Consideraciones">
            <wysiwyg v-model="plan.consideraciones" />
          </base-input>
        </div>
      </div>
      
      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Condiciones generales y especificas">
            <wysiwyg v-model="plan.condiciones" />
          </base-input>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-12">
          <base-checkbox class="mb-3" v-model="plan.payment_required">
            ¿ Requiere pago ?
          </base-checkbox>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-12">
          <base-checkbox class="mb-3" v-model="plan.sign_required">
            ¿ Requiere firma ?
          </base-checkbox>
        </div>
      </div>
      <!--
      <div class="form-row">
        <div class="col-md-6">
          <base-input addon-left-icon="ni ni-calendar-grid-58" label="Fecha de vigencia desde:"
                      name="fecha de vigencia desde"
                      :error="getError('fecha de vigencia desde')"
                      v-validate="'required'"
                      v-model="plan.vigencia_desde"
          >
            <flat-picker slot-scope="{focus, blur}"
                        @on-open="focus"
                        @on-close="blur"
                        :config="config"
                        class="form-control datepicker"
                        v-model="plan.vigencia_desde">
            </flat-picker>
          </base-input>
        </div>
        <div class="col-md-6">
          <base-input addon-left-icon="ni ni-calendar-grid-58" label="Fecha de vigencia hasta:"
                      name="fecha de vigencia hasta"
                      :error="getError('fecha de vigencia hasta')"
                      v-validate="'required'"
                      v-model="plan.vigencia_hasta"
          >
            <flat-picker slot-scope="{focus, blur}"
                        @on-open="focus"
                        @on-close="blur"
                        :config="config"
                        class="form-control datepicker"
                        v-model="plan.vigencia_hasta">
            </flat-picker>
          </base-input>
        </div>
      </div>
      -->
      <div class="form-row">
        <div class="col-md-6">
          <base-input 
            type="number"
            step="1"
            min="1"
            label="Duración de Vigencia"
            v-model="plan.duracion"
          >

          </base-input>
        </div>
        <div class="col-md-6">
          <base-input label="Unidad de tiempo"
            v-model="plan.unidad_duracion"
          >
              <el-select  clearable v-model="plan.unidad_duracion" filterable
                          placeholder="Unidad de tiempo">
                <el-option v-for="option in selectUnidades"
                            :key="option.label"
                            :label="option.label"
                            :value="option.value">
                </el-option>
              </el-select>
          </base-input>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-6">
          <base-input 
            type="number" 
            v-model="plan.limite_siniestros" 
            min="0" label="Límite de siniestros (0 = Ilimitados)" 
            name="Limite de siniestros"
            :error="getError('Limite de siniestros')"
            v-validate="'required|min:0'"  
          />
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-12">
              <base-input label="Moneda en la que se valoriza el plan"
                          name="moneda"
                          :error="getError('moneda')"
                          v-validate="'required'"
                          v-model="plan.moneda"
              >
                  <el-select clearable v-model="plan.moneda" filterable
                              placeholder="Seleccione moneda" ref="selectMoneda" >
                      <el-option v-for="option in selectMonedas"
                                  :key="option.label"
                                  :label="option.label"
                                  :value="option.value">
                      </el-option>
                  </el-select>
              </base-input>
        </div>
    </div>
    <div class="form-row" v-if="plan.moneda != 'CLP'">
          <div class="col-md-6">
            <base-input label="Tipo de conversión">
                <el-select clearable v-model="plan.tipo_conversion" filterable
                            placeholder="Seleccione tipo de conversión">
                    <el-option v-for="option in selectTiposConversion"
                                :key="option.label"
                                :label="option.label"
                                :value="option.value">
                    </el-option>
                </el-select>
            </base-input>
          </div>
          <div class="col-md-6" v-if="plan.tipo_conversion == 'xday'">
            <base-input addon-left-icon="ni ni-calendar-grid-58" label="Ingrese fecha específica:">
              <flat-picker slot-scope="{focus, blur}"
                          @on-open="focus"
                          @on-close="blur"
                          :config="config"
                          class="form-control datepicker"
                          v-model="plan.valor_conversion">
              </flat-picker>
            </base-input>
          </div>
          <div class="col-md-6" v-if="plan.tipo_conversion == 'daysbefore'">
            <base-input v-model="plan.valor_conversion" type="number" label="Indique cantidad de días" min="0" />
          </div>
          <div class="col-md-6" v-if="plan.tipo_conversion == 'weeksbefore'">
            <base-input v-model="plan.valor_conversion" type="number" label="Indique cantidad de semanas" min="0" />
          </div>
          <div class="col-md-6" v-if="plan.tipo_conversion == 'monthsbefore'">
            <base-input v-model="plan.valor_conversion" type="number" label="Indique cantidad de meses" min="0" />
          </div>
          <div class="col-md-6" v-if="plan.tipo_conversion == 'fixedvalue'">
            <base-input  v-model="plan.valor_conversion" type="number" step="0.01" :label="'Indique el valor fijo de la moneda: '+$refs.selectMoneda.selectedLabel" min="0" />
          </div>
      </div>
      <div class="form-row">
        <div class="col-md-12">
          <base-input 
            label="Porcentaje de monto cubierto (**)"
            type="number"
            step="0.01"
            min="0"
            max="100"
            placeholder="Porcentaje cubierto"
            v-model="plan.cubierto"
          >
            <small slot="append" class="font-weight-bold">%</small>
          </base-input>
          <small>** Dejar en 0 si no aplica a este Plan</small>
        </div>
      </div>
      <div class="form-row mt-2">
        <div class="col-md-12">
          <base-input 
            label="Documento descargable"
            type="text"
            placeholder="Link a documento descargable"
            v-model="plan.file_url"
          >
          </base-input>
        </div>
      </div>
      <!--
      <base-input>
        <base-checkbox v-model="model.agree">
          Agree to terms and conditions
        </base-checkbox>
      </base-input>
      -->
    </form>

    <template slot="footer">
      <base-button type="primary" nativeType="submit" form="formEditUser">Guardar Cambios</base-button>
      <base-button type="link" class="ml-auto" @click="showModal = false">Cancelar</base-button>
    </template>

  </modal>
</template>
<script>
import { Select, Option } from 'element-ui';
import BaseTable from '@/components/BaseTable';
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import HtmlEditor from '@/components/Inputs/HtmlEditor';
import VueNumeric from 'vue-numeric';
const FormulaParser = require('hot-formula-parser').Parser;
var parser;

  export default {
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        HtmlEditor,
        flatPicker,
        VueNumeric,
        BaseTable
    },
    data() {
      return {
        config: { dateFormat: 'd-m-Y', allowInput: true },
        validated: false,
        plan: {
          name: '',
          valor: '',
          subcategoria: {id: '', name: ''},
          categoria: { id: '', name: ''},
          compañia: {id: '', name: ''},
          sponsor: {id: '', name: ''},
          campos_enum: [],
          campos_variable: [],
          campos_range: [],
          materia: undefined,
          consideraciones: undefined,
          condiciones: undefined,
          payment_required: undefined,
          sign_required: undefined,
          //vigencia_desde: undefined,
          //vigencia_hasta: undefined,
          moneda: undefined,
          tipo_conversion: undefined,
          valor_conversion: undefined,
          limite_siniestros: undefined,
          duracion: undefined,
          unidad_duracion: undefined,
          cubierto: undefined,
          file_url: ''
        },
        fetchPlan: {
          name: '',
          valor: '',
          cobertura_desde: '',
          cobertura_hasta: '',
          subcategoria: {id: '', name: ''},
          categoria: { id: '', name: ''},
          compañia: {id: '', name: ''},
          sponsor: {id: '', name: ''},
          detalles_html: ''
        },
        showModal: false,
        change_password: "0",
        reglasConfirmacion: '',
        reglasPassword: '',
        plan_id: null,
        selectCategorias: [], // Estos debe ser un arreglo de objetos asi: { label: ...(es lo que se ve), value: ...}
        selectSubcategorias: [],
        selectCompañias: [],
        selectSponsors: [],
        selectMaterias: [],
        campos_enum: [],
        campos_variable: [],
        campos_range: [],
        parser: undefined,
        searattrsData: [],
        letras: ['x', 'y', 'z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w' ],
        formula: '',
        campos_formulas: [],
        selectTiposConversion: [
            {label: 'Default (Fecha actual)' , value: 'current' },
            {label: 'Dia específico', value: 'xday' },
            {label: 'Último cierre mensual', value: 'endlastmonth' },
            {label: 'X dias atrás', value: 'daysbefore' },
            {label: 'X semanas atrás', value: 'weeksbefore' },
            {label: 'X meses atrás', value: 'monthsbefore' },
            {label: 'Valor Fijo', value: 'fixedvalue' }
          ],
        selectMonedas: [],
        selectUnidades: [
          { label: 'Días', value: 'dias' },
          { label: 'Meses', value: 'meses' },
          { label: 'Años', value: 'años' }
        ],
      }
    },
    methods: {
      async firstFormSubmit() {
        try {
          return await this.$validator.validateAll();
          //throw new Error('hno ke wea esta wea');
        } catch {
          console.log('Oh, tengo ke caputar algo');
          return false;
        }
        finally {
          this.validated = true;
        }
      },
      getError(name){
        return this.errors.first(name)
      },
      isValid(name) {
        return this.validated && !this.errors.has(name);
      },
      sendForm(){
        var vm = this;
        this.firstFormSubmit().then( response => {
          console.log('retorno promesa de validacion', response);
          
          if( response ){
            
            vm.axios({
                method: 'PUT',
                url: 'api/edit_plan',
                data: {   
                          plan: vm.plan.id,
                          name: vm.plan.name,
                          categoria: vm.plan.categoria.id,
                          subcategoria: vm.plan.subcategoria.id,
                          sponsor: vm.plan.sponsor.id,
                          company: vm.plan.compañia.id,
                          
                          sign_required: vm.plan.sign_required,
                          payment_required: vm.plan.payment_required,
                          //vigencia_desde: vm.$moment(vm.plan.vigencia_desde, "DD-MM-YYYY").format('YYYY-MM-DD'),
                          //vigencia_hasta: vm.$moment(vm.plan.vigencia_hasta, "DD-MM-YYYY").format('YYYY-MM-DD'),
                          
                          duracion: vm.plan.duracion,
                          unidad_duracion: vm.plan.unidad_duracion,

                          campos_enum: vm.plan.campos_enum,
                          formula: vm.formula,
                          campos_range: vm.plan.campos_range,
                          
                          materia: vm.plan.materia,
                          moneda: vm.plan.moneda,
                          tipo_conversion: ((vm.plan.tipo_conversion == '' || vm.plan.tipo_conversion == undefined) ? 'current': vm.plan.tipo_conversion),
                          valor_conversion: vm.plan.valor_conversion,
                          consideraciones: vm.plan.consideraciones,
                          condiciones: vm.plan.condiciones,
                          campos_variable: vm.plan.campos_variable,
                          limite_siniestros: vm.plan.limite_siniestros,
                          cubierto: vm.plan.cubierto,
                          file_url: vm.plan.file_url
                      }
            }).then( response => {
              vm.$notify({
                      message: 'Plan actualizado exitosamente!',
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'success'
                  });
              // Cerrar el Modal
              vm.showModal = false;
              // Emitir evento para que actualize la tabla de usuarios
              vm.$emit('successSending');
            }).catch( error => {
                
                if( error.response.status == 422){
                  Object.entries(error.response.data.errors).forEach( elem => {
                    vm.$notify({
                      message: elem[1][0],
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'danger'
                    });
                  });
                }else{
                  console.log(error);
                  vm.$notify({
                        message: 'Hubo un error, no se pudo actualizar el plan',
                        timeout: 5000,
                        icon: 'ni ni-bell-55',
                        type: 'default'
                    });
                }
            });
          }
          
        }).catch( reason => {
          console.log(reason);
        });
      },
      fetchDataPlan(plan)
      {
        var vm = this;
        
        return this.axios({
            method: 'GET',
            url: 'api/edit_plan?plan='+plan
        }).then(response => {
            vm.fetchPlan.name = vm.plan.name = response.data.name;
            vm.plan.id = response.data.id;
            vm.plan.valor = response.data.valor;
            //vm.plan.cobertura_desde = response.data.cobertura_desde;
            //vm.plan.cobertura_hasta = response.data.cobertura_hasta;
            vm.plan.duracion = response.data.duracion;
            vm.plan.unidad_duracion = response.data.unidad_duracion;
            vm.plan.categoria = response.data.categoria;
            vm.plan.subcategoria = response.data.subcategoria;
            vm.plan.compañia = response.data.compañia;
            vm.plan.sponsor = response.data.sponsor;
            vm.plan.detalles_html = response.data.detalles_html;
            vm.plan.cubierto = response.data.cubierto;
            vm.showModal = true;
            vm.plan_id = plan;

            vm.fetchCategoriesList(vm.plan.id);
            vm.fetchSubcategoriesList(vm.plan.id, vm.plan.categoria.id);
            vm.fetchCompaniesList(vm.plan.id);
            vm.fetchSponsorList(vm.plan.id);
            vm.fetchMateriasList(vm.plan.id);
            vm.fetchCurrenciesList(vm.plan.id);
            
            vm.parser = new FormulaParser(); 
            vm.searattrsData = response.data.searattrsData;
            vm.campos_formulas =  vm.searattrsData.filter( elem => 
            elem.tipo_campo == 'VARIABLE' || (elem.tipo_campo == 'RANGE' && (elem.tipo_dato == 'float' || elem.tipo_dato == 'int'))
            );
            vm.campos_enum = vm.searattrsData.filter( elem => 
              elem.tipo_campo == 'ENUM'
            );
            vm.plan.campos_enum = [];
            vm.campos_enum.forEach(elem => {
              vm.plan.campos_enum.push(undefined);
            });
            vm.campos_range = vm.searattrsData.filter( elem => 
              elem.tipo_campo == 'RANGE'
            );
            vm.plan.campos_range = [];
            vm.campos_range.forEach( elem => {
              vm.plan.campos_range.push({desde: undefined, hasta: undefined});
            });
            vm.campos_variable = vm.searattrsData.filter( elem =>
              elem.tipo_campo == 'VARIABLE'
            );
            vm.plan.campos_variable = [];
            vm.campos_formulas.forEach( (elem, i) => {
              vm.plan.campos_variable.push({id: elem.id, letra: vm.letras[i]});
              vm.parser.setVariable(vm.letras[i], 1);
              console.log('vm.parser.setVariable',vm.letras[i], 1);
            });
            vm.campos_enum.forEach( (elem, index) => {
              vm.plan.campos_enum[index] = response.data.filters.campos_enum.find( el => el.id == elem.id).plan_value || undefined;
            });
            vm.campos_range.forEach( (elem, index) => {
              vm.plan.campos_range[index].desde = response.data.filters.campos_range.find( el => el.id == elem.id).plan_desde || undefined;
              vm.plan.campos_range[index].hasta = response.data.filters.campos_range.find( el => el.id == elem.id).plan_hasta || undefined;
            });
            vm.formula = response.data.formula;
            vm.plan.materia = response.data.materia.id;
            vm.plan.consideraciones = response.data.consideraciones;
            vm.plan.condiciones = response.data.condiciones;
            vm.plan.payment_required = response.data.payment_required;
            vm.plan.sign_required = response.data.sign_required;
            //vm.plan.vigencia_desde = response.data.vigencia_desde;
            //vm.plan.vigencia_hasta = response.data.vigencia_hasta;

            vm.plan.duracion = response.data.duracion;
            vm.plan.unidad_duracion = response.data.unidad_duracion;

            vm.plan.moneda = response.data.moneda;
            vm.plan.tipo_conversion = response.data.tipo_conversion;
            vm.plan.valor_conversion = response.data.valor_conversion;
            vm.plan.limite_siniestros = response.data.limite_siniestros;
            vm.plan.file_url  = response.data.file_url;
        }).catch( error => {
            console.log(error);
        })
        ;
      },
      fetchCategoriesList(plan_id)
      {
        var vm = this;
        return this.axios({ 
          //Debe Traer solo la lista de categorias que puede cambiar el usuario
          method: 'POST',
          url: 'api/fetch_categories_plan',
          data: {plan: plan_id}
        }).then( response => {
          vm.selectCategorias = response.data;
        }).catch( error => {
          console.log(error);
        });
      },
      fetchSubcategoriesList(plan_id, categoria_id)
      {
        var vm = this;
        return this.axios({ 
          //Debe Traer solo la lista de subcategorias que puede cambiar el usuario
          method: 'POST',
          url: 'api/fetch_subcategories_plan',
          data: {plan: plan_id, categoria: categoria_id}
        }).then( response => {
          vm.selectSubcategorias = response.data;
        }).catch( error => {
          console.log(error);
        });
      },
      fetchCompaniesList(plan_id)
      {
        var vm = this;
        return this.axios({ 
          //Debe Traer solo la lista de compañias que puede cambiar el usuario
          method: 'POST',
          url: 'api/fetch_companies_plan',
          data: {plan: plan_id}
        }).then( response => {
          vm.selectCompañias = response.data;
        }).catch( error => {
          console.log(error);
        });
      },
      fetchSponsorList(plan_id)
      {
        var vm = this;
        return this.axios({ 
          //Debe Traer solo la lista de compañias que puede cambiar el usuario
          method: 'POST',
          url: 'api/fetch_sponsors_plan',
          data: {plan: plan_id}
        }).then( response => {
          vm.selectSponsors = response.data;
        }).catch( error => {
          console.log(error);
        });
      },
      fetchMateriasList(plan_id)
      {
        var vm = this;
        return this.axios({ 
          //Debe Traer solo la lista de compañias que puede cambiar el usuario
          method: 'POST',
          url: 'api/fetch_materias_plan',
          data: {plan: plan_id}
        }).then( response => {
          vm.selectMaterias = response.data;
        }).catch( error => {
          console.log(error);
        });
      },
      fetchCurrenciesList(plan_id)
      {
        var vm = this;
        return this.axios({ 
          //Debe Traer solo la lista de compañias que puede cambiar el usuario
          method: 'POST',
          url: 'api/fetch_currencies_plan',
          data: {plan: plan_id}
        }).then( response => {
          vm.selectMonedas = response.data;
        }).catch( error => {
          console.log(error);
        });
      },
      updateSubcategoriasList(categoria_id)
      {
        this.fetchSubcategoriesList(this.plan_id, this.plan.categoria.id);
      }
    },
    mounted()
    {
        
    },
    created()
    {
      this.$parent.$on('loadModalEditPlan', (plan) => { this.fetchDataPlan(plan) } );
      this.parser = new FormulaParser();
    },
    watch: {
        change_password(value)
        {
            if(this.change_password == '0'){
                this.user.password = '';
                this.user.password_confirmation = '';
                this.reglasPassword = ''
                this.reglasConfirmacion = '';
            } else {
                this.reglasPassword = 'required|min:6';
                this.reglasConfirmacion = 'required|min:6|confirmed:contraseña'
            }
        }
    },
    computed: {
      formulaComputed(){
        return this.parser.parse(this.formula).result? true: false;
      },
    }
  }
</script>
<style>
@import "~vue-wysiwyg/dist/vueWysiwyg.css";
</style>
